import { Component, OnInit } from '@angular/core';
import { FileSaverService } from 'ngx-filesaver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';
import { ValidateImage } from 'src/app/shared/models/validate-image.model';
import Swal from 'sweetalert2'
import { LoadingImagesService } from '../loading-images/loading-images.service';
import { AuthUser } from 'src/app/shared/models/auth-user.model';

@Component({
  selector: 'app-bulk-load',
  templateUrl: './bulk-load.component.html',
  styleUrls: ['./bulk-load.component.scss']
})
export class BulkLoadComponent implements OnInit {

  files: FileHandle[];
  imageList: ValidateImage[];
  fileList: File[];
  currentUser: AuthUser;

  private deleteSubscription: Subscription = null;

  constructor(private fileSaverService: FileSaverService,
    private loader: NgxSpinnerService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private loadingImagesService: LoadingImagesService) { }

  ngOnInit() {
    this.files = [];
    this.fileList = [];
  }

  ngOnDestroy(): void {
    if (this.deleteSubscription !== null) { this.deleteSubscription.unsubscribe(); }
  }

  filesDropped(files: FileHandle[]): void {
    this.files = files;
  }

  validateFiles(): void {

    this.imageList = [];


    if (this.files.length !== 0) {

      for (let i in this.files) {

        var archive = new ValidateImage(i);
        archive.name = this.files[i].file.name.toLowerCase();
        archive.format = archive.name.substr(-3);

        //obtiene el nombre del archivo eliminando y validado que inicie con el isbn o clave oracle
        if (archive.name.includes('_')) {
          var numberIndex = archive.name.indexOf('_');
        } else {
          var numberIndex = archive.name.indexOf('-');
        }

        var name = archive.name.substr(0, numberIndex);

        if (archive.format == 'pdf') {

          if (name.match("^[0-9]+$")) {

            if (archive.name.includes('fichatecnica')) {
              // this.imageList.push(archive);
              this.fileList.push(this.files[i].file);
        
            }
          }
        }
      }
    } else {
      this.toastr.error('No se han cargado imágenes', 'Campos Faltantes');
    }
  }

  uploadMassiveFiles(): void {

    this.loader.show();

    this.currentUser = JSON.parse(localStorage.getItem('gbi_auth_user'));

    this.loadingImagesService.uploadFiles(this.fileList, this.currentUser.email).subscribe((response: any) => {

        this.files = [];
        this.imageList = [];
        this.fileList = [];

        this.loader.hide();
        this.toastr.info(`Los archivos se guardaron correctamente`);

      }, (error) => {
        console.error(error);
        console.log(error);
        this.loader.hide();
        this.toastr.error(`Ha ocurrido un error al guardar la imagen, ${error}`, 'Error');
      });  
  }

  onDeleteFiles(name: string, index: number): void {

    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {

      if (result.value) {
        this.spinner.show();

        this.fileList.splice(index, 1)
        // this.imageList.splice(index, 1);

        this.spinner.hide();
        Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
      }
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
      console.error('error to delete item', error);
    });

  }

}
